import { NavLink } from 'react-router-dom';
import env from '../../utils/env';
import MyIcon from '../MyIcon/MyIcon';
import './Sidebar.css';

function Sidebar({ className, onCloseSidebar }) {
  const config = env();

  const closeSidebar = () => {
    onCloseSidebar();
  };

  return (
    <aside className={'sidebar' + className}>
      <ul className="nav flex-column">
        <li className="nav-item">
          <span className="nav-link"><MyIcon name="home" color="#d2d6dc"/>Tổng quan</span>
          <ul>
            <li className="nav-item">
              <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/"><MyIcon name="user" color="transparent"/>Cá nhân</NavLink>
            </li>
            <li className="nav-item">
              <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/leader"><MyIcon name="user-star" color="transparent"/>Trưởng nhóm</NavLink>
            </li>
          </ul>
        </li>
        <li className="nav-item">
          <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/urls"><MyIcon name="link" color="#d2d6dc"/>Link giới thiệu</NavLink>
        </li>
        <li className="nav-item">
          <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/referrals"><MyIcon name="card" color="#d2d6dc"/>Lượt giới thiệu</NavLink>
        </li>
        <li className="nav-item">
          <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/payouts"><MyIcon name="money" color="#d2d6dc"/>Thanh toán</NavLink>
        </li>
        <li className="nav-item">
          <NavLink onClick={closeSidebar} to="/visits" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}><MyIcon name="click" color="#d2d6dc"/>Lượng truy cập</NavLink>
        </li>
        <li className="nav-item">
          <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/creatives"><MyIcon name="image" color="transparent"/>Hình ảnh chiến dịch</NavLink>
        </li>
        <li className="nav-item">
          <a className="nav-link" href={`${config.apiURL}/affiliate-area/faq/`}><MyIcon name="docs" color="transparent"/>Tài liệu hỗ trợ</a>
        </li>
        <li className="nav-item">
          <NavLink onClick={closeSidebar} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} to="/profile/"><MyIcon name="profile" color="transparent"/>Cập nhật profile</NavLink>
        </li>
      </ul>
    </aside>
  )
}

export default Sidebar;
